import React from 'react';

import UseEffectExample from './hooks/use-effect-example.component';

import '../App.css';

const HooksUseEffect = props => {
  return <UseEffectExample />;
};

export default HooksUseEffect;